import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import SideMenu from "./SideMenu";
import { useLocation, useNavigate } from "react-router-dom";
import Categorias from "./Categorias";
import FormasPagamento from "./FormasPagamento";
import { ConfirmProvider } from "material-ui-confirm";
import ScreenBanner from "../../../../components/ScreenBanner";
import DialogConfigPedidos from "./ConfigPedidos";
import Consultores from "./Consultores";
import Promocoes from "./Promocoes";
import PermissionGuard from "../../../../components/PermissionGuard";
import Boletos from "./Boletos";

export default function ConfiguracoesComercial() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const [configSelecionada, setConfigSelecionada] = useState<TConfigSelect>(
    (params.get("menu") as TConfigSelect) || "Boletos"
  );

  //Funções Manipuladoras
  const handleSelectItemConfig = useCallback(
    (config: TConfigSelect) => {
      setConfigSelecionada(config);
      navigate(`/comercial/configuracoes?menu=${config}`);
    },
    [navigate]
  );
  //

  //Valores importantes
  const renderContent = useMemo(() => {
    if (configSelecionada === "Boletos") {
      return <Boletos />;
    }
    if (configSelecionada === "Formas de Pagamento") {
      return <FormasPagamento />;
    }
    if (configSelecionada === "Categorias") {
      return <Categorias />;
    }
    if (configSelecionada === "Pedido configurações") {
      return <DialogConfigPedidos />;
    }
    if (configSelecionada === "Consultores") {
      return <Consultores />;
    }
    if (configSelecionada === "Promoções") {
      return <Promocoes />;
    }
  }, [configSelecionada]);

  //

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setConfigSelecionada((params.get("menu") as TConfigSelect) || "Boletos");
  }, [location.search]);

  return (
    <>
      <ScreenBanner title="Comercial" />
      <PermissionGuard permissionId="comercial.configuracoes">
        <Container sx={{ my: 4 }}>
          <Typography textAlign="center" variant="h5">
            Configurações comercial
          </Typography>

          <Grid container spacing={2} mt={1}>
            <Grid size={{xs:12, md: 4}}>
              <Box component={Paper} p={2}>
                <SideMenu
                  select={configSelecionada}
                  handleSelect={(item) => handleSelectItemConfig(item)}
                />
              </Box>
            </Grid>

            <Grid size={{xs:12, md: 8}}>
              <Box component={Paper} p={2}>

                <ConfirmProvider
                  defaultOptions={{
                    title: "Excluir item",
                    cancellationText: "Cancelar",
                    confirmationText: "Excluir",
                    confirmationButtonProps: {
                      variant: "contained",
                      color: "error",
                    },
                  }}
                >
                  {renderContent}
                </ConfirmProvider>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </PermissionGuard>
    </>
  );
}

export type TConfigSelect =
  | "Categorias"
  | "Formas de Pagamento"
  | "Pedido configurações"
  | "Consultores"
  | "Promoções"
  | "Boletos";

export type TConfigModalState = {
  [key in TConfigSelect]: boolean;
};
